export default __webpack_public_path__ + "static/media/File Security.dd615b00.svg";